<template>
  <div>
    <ModuleHeader>Ventas Producto por Hora</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="10" cols="12">
                <v-row>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date" label="Fecha Inicial" prepend-icon="mdi-calendar" readonly
                          @input="getAperturas()" v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date"
                        @input="menuFechaInicial = false; getAperturas();"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar"
                          @input="getAperturas()" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="input_date_final"
                        @input="menuFechaInicial2 = false; getAperturas();"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="4" cols="6">
                    <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
                      @input="getAperturas()" :items="departamentos"></v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_familias" label="Familias" :items="familiasList" item-value="id"
                      item-text="Nombre">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete v-model="input_categoria" label="Categoría del producto" :items="categoriesList"
                      multiple item-value="id" item-text="label">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="4" cols="12" class="mt-n6">
                    <v-autocomplete :items="global_prod" v-model="selectedProducts" multiple item-value="id"
                      item-text="Nombre" label="Productos">
                    </v-autocomplete>
                  </v-col>
                  <v-col md="6" cols="12" class="mt-n6">
                    <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                      :items="turnosList">
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="text-right mt-n5" md="12" cols="12">
                <v-btn depressed @click="cleanFilter()" class="mx-2" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="12">
        <v-card elevation="0">
          <v-tabs v-model="tab" color="primary" class="mb-4">
            <v-tab>Resumen por Producto</v-tab>
            <v-tab>Detalle por Hora</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col md="4" cols="12">
                    Resultados de ventas por producto
                  </v-col>
                  <v-col md="8" cols="12" class="text-right">
                    <v-btn color="green" dark @click="exportExcel()"><v-icon>mdi-file-excel-box</v-icon>
                      Exportar a Excel
                    </v-btn>
                  </v-col>
                </v-row>
                <uv-data-table v-if="render" ref="uvDataTable" :config="config" :data="dataProductos" :pageRows="15"
                  @buttonClick="dtButtonClick"></uv-data-table>
              </v-card-text>
            </v-tab-item>

            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col md="4" cols="12">
                    Desglose de ventas por hora
                  </v-col>
                  <v-col md="8" cols="12" class="text-right">
                    <v-btn color="green" dark @click="exportExcelPorHora()"><v-icon>mdi-file-excel-box</v-icon>
                      Exportar a Excel
                    </v-btn>
                  </v-col>
                </v-row>
                <v-simple-table class="dense-table mt-4" dense>
                  <thead>
                    <tr>
                      <th class="text-left">Hora</th>
                      <th class="text-left">Folio</th>
                      <th class="text-left">Producto</th>
                      <th class="text-left">Cantidad</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in datos.porHora">
                      <tr :key="'h-' + index">
                        <td :rowspan="item.Productos.length"
                          style="vertical-align: top; font-weight: bold; border-right: 1px solid #e0e0e0;">
                          {{ item.Hora }}
                        </td>
                        <td v-if="item.Productos.length > 0">{{ item.Productos[0].Folio }}</td>
                        <td v-if="item.Productos.length > 0">{{ item.Productos[0].Nombre }}</td>
                        <td v-if="item.Productos.length > 0">{{ item.Productos[0].Cantidad }}</td>
                      </tr>
                      <tr v-for="(prod, i) in item.Productos.slice(1)" :key="'p-' + index + '-' + i">
                        <td>{{ prod.Folio }}</td>
                        <td>{{ prod.Nombre }}</td>
                        <td>{{ prod.Cantidad }}</td>
                      </tr>
                    </template>
                    <tr v-if="datos.porHora.length === 0">
                      <td colspan="4" class="text-center py-4">No hay ventas registradas en el periodo seleccionado</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal para el detalle de horas -->
    <v-dialog v-model="detalleHorasModal" max-width="850">
      <v-card>
        <v-card-title class="text-h5">
          Ventas por hora: {{ detalleHorasTitle }}
        </v-card-title>
        <v-card-text>
          <div id="chart-container-detalle" class="mb-4">
            <fusioncharts
              :type="'column2d'"
              :width="'100%'"
              :height="'300'"
              :renderAt="'chart-container-detalle'"
              :dataformat="'json'"
              :dataSource="chartDataSource"
            >
            </fusioncharts>
          </div>
          <v-simple-table class="dense-table" dense>
            <thead>
              <tr>
                <th>Hora</th>
                <th>Cantidad Vendida</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in detalleHorasData" :key="index">
                <td>{{ item.hora }}:00 - {{ item.hora }}:59</td>
                <td><b :style="{ color: (item.cantidad === 0) ? '#ff0000' : '#0c17b0' }">{{
                  item.cantidad }}</b></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detalleHorasModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "../../../assets/css/custom.css";
import "../../../assets/css/sideBar.css";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
import uvDataTable from "../../../components/MainComponents/DataTable.vue";

export default {
  name: "ReporteVentaProductosHora",
  components: {
    uvDataTable,
  },
  data() {
    return {
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id",
        },
        orderByCol: { Field: "", Type: "Desc" },
        fields: [
          { text: "Nombre", value: "Nombre" },
          { text: "Familia", value: "FamiliaName", canBeFiltered: true },
          { text: "Categoria", value: "CategoriaName", canBeFiltered: true },
          { text: "Total Vendidos", value: "Vendidos", },
          {
            text: "Total Neto",
            value: "Total",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row.Total);
            },
          },
          { text: "Hora mas vendida", value: "HoraPico" },
          { text: "Ventas en hora pico", value: "CantidadHoraPico" },
          {
            text: "Opciones",
            value: "Id",
            buttons: [
              {
                color: "primary",
                text: "Ver Detalle por Hora",
                buttonId: "detalleHoras",
                value: "Id",
              },
            ],
          },
        ],
      },

      tab: null,
      detalleHorasModal: false,
      detalleHorasTitle: "",
      detalleHorasData: [],
      chartDataSource: {},

      selectedProducts: [],
      selectDep: "ALL",
      selectTurno: "ALL",
      input_familias: "ALL",
      input_categoria: ["ALL"],
      aperturas: [],

      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      render: true,

      datos: {
        all: [],
        processedData: [],
        porHora: [],
      },

      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      Categories: [],
      familias: [],
      data_cajas: [],
      cashiers: [],
    };
  },
  computed: {
    ...mapGetters(["getProductos"]),
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    global_prod() {
      let productos = [];
      this.getProductos.forEach((element) => {
        if (
          element.Tipo != "AYB-Insumo" &&
          element.Tipo != "AYB-ICompuesto" &&
          !element.Dlat
        ) {
          productos.push(element);
        }
      });
      return productos;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    dataProductos() {
      return [...this.datos.processedData].sort((a, b) => b.Vendidos - a.Vendidos);
    },
    categoriesList() {
      let categories = [{ id: "ALL", label: "TODOS" }];
      this.Categories.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    familiasList() {
      let categories = [
        { id: "ALL", Nombre: "TODOS" },
      ];
      this.familias.forEach((categoria) => {
        categories.push(categoria);
      });
      return categories;
    },
    departamentos() {
      let dep = [
        { id: "ALL", Nombre: "Todos" },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    filteredTableData() {
      return this.$refs.uvDataTable.retrieveData();
    },
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "detalleHoras") {
        this.showDetailHoras(idSelected);
      }
    },
    showDetailHoras(id) {
      let prod = this.datos.processedData.find((x) => x.Id == id);
      if (prod) {
        let horas = Object.entries(prod.ByHour)
          .map(([hora, cant]) => ({ hora, cantidad: cant }))
          .sort((a, b) => parseInt(a.hora) - parseInt(b.hora));

        this.detalleHorasData = horas;
        this.detalleHorasTitle = prod.Nombre;

        const chartData = horas.map((h) => ({
          label: `${h.hora}:00`,
          value: h.cantidad,
        }));

        this.chartDataSource = {
          chart: {
            caption: "Ventas por Hora",
            subCaption: prod.Nombre,
            xAxisName: "Hora",
            yAxisName: "Cantidad Vendida",
            theme: "fusion",
            showValues: "1",
            paletteColors: "#1976D2",
          },
          data: chartData,
        };

        this.detalleHorasModal = true;
      }
    },
    exportExcel() {
      const formattedData = this.filteredTableData.map((item) => {
        return {
          Nombre: item.Nombre,
          Familia: item.FamiliaName,
          Categoria: item.CategoriaName,
          "Total Vendidos": Number(item.Vendidos),
          "Total Neto": Number(item.Total),
          "Hora mas vendida": item.HoraPico,
          "Ventas en hora pico": item.CantidadHoraPico,
        };
      });

      const options = {
        json_fields: {
          Nombre: "Nombre",
          Familia: "Familia",
          Categoria: "Categoria",
          "Total Vendidos": "Total Vendidos",
          "Total Neto": "Total Neto",
          "Hora mas vendida": "Hora mas vendida",
          "Ventas en hora pico": "Ventas en hora pico",
        },
      };

      GenericExcelExporter.generateExcelBuffer(formattedData, options)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Ventas por hora.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    exportExcelPorHora() {
      let dataToExcel = [];
      this.datos.porHora.forEach((item) => {
        item.Productos.forEach((prod) => {
          dataToExcel.push({
            Hora: item.Hora,
            Folio: prod.Folio,
            Producto: prod.Nombre,
            Cantidad: prod.Cantidad,
          });
        });
      });
      GenericExcelExporter.generateExcelBuffer(dataToExcel)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Detalle ventas por hora y ticket.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    async getAperturas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(this.cashiers, "Id", apt.Cajero);

        let nombCaja = caja ? caja.Nomb : 'Caja ' + apt.Caja;
        let nombCajero = cajeroData ? cajeroData.Nomb : 'Cajero ' + apt.Cajero;

        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          nombCaja +
          " || " +
          nombCajero +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    async getCajas() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/Cajas");
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder("PDV/Cajeros");
      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    async getFamilias() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Productos/Familias"
      );
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    cleanFilter() {
      this.input_date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
      this.input_date_final = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
      this.selectDep = "ALL";
      this.selectTurno = "ALL";
      this.selectedProducts = [];
      this.input_categoria = ["ALL"];
      this.input_familias = "ALL";
    },
    async getVentas() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }

      let listVentas = [];

      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        if (this.selectDep != "ALL") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }

        filter.push(firestore.where("Turno", "==", id));

        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        data.docs.forEach((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
        });
      });

      await Promise.all(taskTurnos).then(() => {
        listVentas.forEach((item) => {
          item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
        });

        this.datos.all = listVentas;
      });
    },
    processVentas() {
      console.time("ProcessVentasHora");
      let productosSum = {};

      let ventasDetalle = [];
      this.datos.all.forEach((el) => {
        let horaVenta = moment(el.FechaCreacion).format("HH");

        el.Catalogo.forEach((prod) => {
          try {
            let precio = 0;
            if (prod.Pagos) {
              Object.entries(prod.Pagos).forEach((pago) => {
                precio += pago[1].def.C;
              });
            }
            let cantidad = prod.Cnt - (prod.Dto ? prod.Dto : 0);

            if (cantidad > 0) {
              prod.OriginalId = prod.OriginalId || prod.Id;

              // Agregar al arreglo para el detalle por hora
              ventasDetalle.push({
                Hora: horaVenta,
                Folio: el.Folio,
                Nombre: prod.Nombre,
                Cantidad: cantidad,
                Categoria: prod.Categoria?.I || "",
                Familia: prod.Familia?.I || "",
                OriginalId: prod.OriginalId,
              });

              if (!productosSum[prod.Id]) {
                let byHour = {};
                for (let i = 0; i < 24; i++) {
                  byHour[i.toString().padStart(2, "0")] = 0;
                }
                byHour[horaVenta] += cantidad;

                productosSum[prod.Id] = {
                  Id: prod.Id,
                  OriginalId: prod.OriginalId,
                  Categoria: prod.Categoria?.I || "",
                  CategoriaName: prod.Categoria?.N || "",
                  Familia: prod.Familia?.I || "",
                  FamiliaName: prod.Familia?.N || "",
                  Nombre: prod.Nombre,
                  Vendidos: cantidad,
                  Total: Number(precio),
                  ByHour: byHour,
                };
              } else {
                productosSum[prod.Id].Vendidos += cantidad;
                productosSum[prod.Id].Total += Number(precio);
                productosSum[prod.Id].ByHour[horaVenta] += cantidad;
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
      });

      let preData = Object.entries(productosSum);
      let arrayData = [];

      preData.forEach((data) => {
        let prod = data[1];

        // Calcular estadísticas
        let maxCantidad = 0;
        let horaPico = "";
        let horasActivas = 0;

        for (let i = 0; i < 24; i++) {
          let horaKey = i.toString().padStart(2, "0");
          let cant = prod.ByHour[horaKey];
          if (cant > 0) {
            horasActivas++;
          }
          if (cant > maxCantidad) {
            maxCantidad = cant;
            horaPico = horaKey + ":00";
          }
        }

        prod.HoraPico = maxCantidad > 0 ? horaPico : "N/A";
        prod.CantidadHoraPico = maxCantidad;

        // Filtros
        if (this.input_familias != "ALL") {
          if (!this.input_categoria.includes("ALL")) {
            if (
              this.input_categoria.includes(prod.Categoria) &&
              this.input_familias == prod.Familia
            ) {
              arrayData.push(prod);
            }
          } else {
            if (this.input_familias == prod.Familia) {
              arrayData.push(prod);
            }
          }
        } else {
          if (!this.input_categoria.includes("ALL")) {
            if (this.input_categoria.includes(prod.Categoria)) {
              arrayData.push(prod);
            }
          } else {
            arrayData.push(prod);
          }
        }
      });

      if (this.selectedProducts.length > 0) {
        arrayData = arrayData.filter((item) =>
          this.selectedProducts.includes(item.OriginalId)
        );
      }

      this.datos.processedData = arrayData;

      // Construir data para el detalle por hora
      let filteredDetalle = ventasDetalle.filter((prod) => {
        let matchFam = true;
        let matchCat = true;
        let matchProd = true;

        if (this.input_familias != "ALL") {
          matchFam = this.input_familias == prod.Familia;
        }
        if (!this.input_categoria.includes("ALL")) {
          matchCat = this.input_categoria.includes(prod.Categoria);
        }
        if (this.selectedProducts.length > 0) {
          matchProd = this.selectedProducts.includes(prod.OriginalId);
        }

        return matchFam && matchCat && matchProd;
      });

      let groupedByHour = {};
      for (let i = 0; i < 24; i++) {
        groupedByHour[i.toString().padStart(2, "0")] = [];
      }
      filteredDetalle.forEach((item) => {
        groupedByHour[item.Hora].push(item);
      });

      this.datos.porHora = Object.keys(groupedByHour)
        .map((hora) => {
          return {
            Hora: hora + ":00 - " + hora + ":59",
            Productos: groupedByHour[hora],
          };
        })
        .filter((h) => h.Productos.length > 0)
        .sort((a, b) => a.Hora.localeCompare(b.Hora));

      console.timeEnd("ProcessVentasHora");
    },
    searchVentas() {
      this.loadingData = true;
      this.getVentas()
        .then(() => {
          this.processVentas();
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
  beforeMount: function () {
    this.getCajas().then(() => {
      this.getCashiers().then(() => {
        this.getAperturas();
      })
    })
    this.getCategories();
    this.getFamilias();
    this.$emit("useNav", true);
  },
};
</script>

<style scoped></style>
